import DefaultBlock from "/scripts/default/block";
import gsap from "gsap";
import { CustomWiggle, Draggable, InertiaPlugin } from "gsap/all";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

gsap.registerPlugin(Draggable, InertiaPlugin, CustomWiggle);

export default class SvgDrag extends DefaultBlock {
	init() {
		const el = {
			objects: this.block.querySelector(".svg-drag__objects"),
			flower: this.block.querySelector("#svg-drag--flower"),
			polygon: this.block.querySelector("#svg-drag--polygon"),
			semiCirlce: this.block.querySelector("#svg-drag--semiCirlce"),
			circle: this.block.querySelector("#svg-drag--circle"),
			flowerWrapper: this.block.querySelector("#svg-drag-item--flower"),
			polygonWrapper: this.block.querySelector("#svg-drag-item--polygon"),
			semiCirlceWrapper: this.block.querySelector("#svg-drag-item--semiCirlce"),
			circleWrapper: this.block.querySelector("#svg-drag-item--circle"),
		};
		this.el = el;

		this.flowerDraggable = null;
		this.polygonDraggable = null;
		this.semiCircleDraggable = null;
		this.circleDraggable = null;

		this.bounds = this.el.objects;

		this.initSVGDrag();
	}

	wiggle() {
		CustomWiggle.create("wiggle", { wiggles: 10, type: "anticipate" });

		const tl = gsap.timeline({
			repeat: -1,
			repeatDelay: 3,
			defaults: {
				ease: "wiggle",
				duration: 2,
			},
		});

		tl.to([this.el.flowerWrapper, this.el.semiCirlceWrapper], {
			rotation: 5,
			stagger: 2.5,
		});
		tl.to([this.el.polygonWrapper, this.el.circleWrapper], {
			y: 10,
			stagger: 2.5,
		});
	}

	// Spin Flower
	flowerInstance() {
		this.flowerDraggable = Draggable.create(this.el.flower, {
			type: "rotation",
			inertia: true,
			throwProps: true,
			maxDuration: 1,
		});
	}

	// Spin Semicircle
	semiCircleInstance() {
		this.semiCircleDraggable = Draggable.create(this.el.semiCirlce, {
			type: "rotation",
			inertia: true,
			throwProps: true,
			maxDuration: 1,
		});
	}

	// Drag and snap polygon
	polygonInstance() {
		const polygon = this.el.polygon;

		this.polygonDraggable = Draggable.create(polygon, {
			inertia: true,
			overshootTolerance: 0,
			maxDuration: 1,
			bounds: this.bounds,
			zIndexBoost: false,
			onThrowComplete: function () {
				gsap.to(polygon, {
					x: 0,
					y: 0,
					duration: 0.5,
				});
			},
		});
	}

	// Drag and snap circle
	circleInstance() {
		const circle = this.el.circle;

		this.circleDraggable = Draggable.create(circle, {
			inertia: true,
			overshootTolerance: 0,
			maxDuration: 1,
			bounds: this.bounds,
			zIndexBoost: false,
			onThrowComplete: function () {
				gsap.to(circle, {
					x: 0,
					y: 0,
					duration: 0.5,
				});
			},
		});
	}

	initSVGDrag() {
		watchPreferredMotion(() => {
			this.flowerInstance();
			this.polygonInstance();
			this.semiCircleInstance();
			this.circleInstance();
			this.wiggle();
		});
	}
}
